import { EventEdit } from "../../event-master/edit-event/EventEdit";
import React from "react";
export const EditEventProcess = () => {
    return React.createElement(EventEdit, null);
};
